import React from "react";

import { AcceptanceFooter } from "layouts/AcceptancePage/components";
import { Box, makeStyles } from "@material-ui/core";
import { Brand } from "@ds-developer/models";
import { FormCard } from "layouts/Auth/components";
import { SignUp } from "@hubcapp/views/Auth";
import { useQueryForAcceptanceData } from "../../AcceptancePageComponent/hooks";

import clsx from "clsx";

type Props = {
  brand: string;
  result: string;
  agreementKey: string;
};

const useStyles = makeStyles(() => ({
  boxBsm: {
    fontFamily: "Poppins !important",
    fontStyle: "normal",
  },
  boxAa: {
    fontFamily: "New Transport AA !important",
    fontStyle: "normal",
  },
  text: {
    fontStyle: "normal",
    fontSize: "18px",
    color: "#2B2929",
    marginBottom: "61px",
  },
  textAa: {
    fontFamily: "New Transport AA !important",
    fontWeight: 400,
    lineHeight: "27px",
  },
  textBsm: {
    fontFamily: "Poppins !important",
    fontWeight: 300,
    lineHeight: "150%",
    letterSpacing: "-0.3px",
  },
}));

const AcceptancePageResult: React.FC<Props> = ({
  brand,
  result,
  agreementKey,
}) => {
  const { data } = useQueryForAcceptanceData({
    agreementKey,
  });
  const classes = useStyles();
  localStorage.clear();
  return (
    <>
      <Box
        className={clsx({
          [classes.boxBsm]: brand === "BSM" ? [classes.boxAa] : brand !== "BSM",
        })}
        marginTop={3}
      >
        <p
          className={clsx(classes.text, {
            [classes.textAa]: brand !== "BSM",
            [classes.textBsm]: brand === "BSM",
          })}
        >
          {result === "success"
            ? "Next steps are to upload your documents through Hubcapp so we can get your franchise started. Create your account or login below to continue."
            : "Unfortunately we were unable to process your application at this time. A member of the team will be in touch shortly to discuss your application further, alternatively get in touch by using the link below.  "}
        </p>
        {result === "success" ? (
          <FormCard
            brand={brand === "bsm" || brand === "BSM" ? Brand.Bsm : Brand.Aad}
          >
            <SignUp
              initialFormFields={{
                adiNumber: data?.franchiseAgreement.adiNumber.toString() || "",
              }}
            />
          </FormCard>
        ) : (
          <p>Contact the team</p>
        )}
      </Box>
      <AcceptanceFooter brand={brand} />
    </>
  );
};

export default AcceptancePageResult;
